//export const baseUrl = 'https://hafele-api.evolve-brands.co/api/v1/'
export const baseUrl = 'https://api.hafelecup.in/api/v1/' //prod
export const av = "1.0";
export const pt = "WEBSITE";
export const company = "1";
export const program = "1";